import React, { Fragment } from 'react'
import { host } from '../../../../configuraciones';
import axios from 'axios'
import ModalMensajeComponent from '../../../App/ModalMensajeComponent';
import Button from '@mui/material/Button';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

function BotonVerDictamenesComponent(props) {
    //ejemplos
    //<BotonVerDictamenesComponent tabla={'documentodictamenfiscal'} nombreId={'idcliente'} idSolicitud={10} />
    const { tabla, nombreId, idSolicitud } = props
    const [openModal, setOpenModal] = React.useState(false)
    const verArchivo = async () => {
        const fileFetch = await fetch(host + `Clientes/servirDictamen/tabla=${tabla}&nombreId=${nombreId}&idSolicitud=${idSolicitud}`)

        if (fileFetch.status != 404) {
            const blob = await fileFetch.blob();
            const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
            window.open(url);
        } else {
            setOpenModal(true)
        }
    }

    return (
        <Fragment>
            <Button onClick={() => verArchivo()} variant="contained" startIcon={<PictureAsPdfIcon />} disabled={idSolicitud != null && idSolicitud != undefined ? false : true}> Descargar PDF </Button>
            {
                openModal &&
                <ModalMensajeComponent setOpenModal={{ setOpenModal }} titleModal={'Error'} bodyModal={'No hay archivos adjuntos'}></ModalMensajeComponent>
            }
        </Fragment>
    )
}

export default BotonVerDictamenesComponent